<template>
  <div class="menu-wrapper">
    <template v-for="item in routes" v-if="!item.hidden && item.children">
      <router-link
        v-if="
          hasOneShowingChildren(item.children) &&
          !item.children[0].children &&
          !item.alwaysShow
        "
        :to="item.path + '/' + item.children[0].path"
        :key="item.children[0].name"
      >
        <el-menu-item
          :index="item.path + '/' + item.children[0].path"
          :class="{ 'submenu-title-noDropdown': !isNest }"
        >
          <svg-icon
            v-if="
              item.children[0].meta &&
              item.children[0].meta.icon &&
              item.children[0].meta.title !== '首页'
            "
            :icon-class="item.children[0].meta.icon"
          ></svg-icon>
          <!-- <div
            v-else-if="item.children[0].meta && item.children[0].meta.icon"
            class="new-year"
          >
            <span class="bg"></span>
            <span class="text">{{ newYear() }}</span>
          </div> -->

          <!-- ================ 红点泡泡 数量展示 start ================ -->
          <div
            v-if="unallocatedShowPointWithParent(item)"
            class="unDoDot unDoDotAni"
          >
            {{ unallocatedShowPointWithParent(item) }}
          </div>
          <!-- ================ 红点泡泡 数量展示 end ================ -->

          <span
            v-if="
              item.children[0].meta &&
              item.children[0].meta.title &&
              item.children[0].meta.title === '首页'
            "
          >
            <span v-if="item.children[0].meta.title === '首页'">{{
              $store.state.app.switchProjectObj.title
            }}</span>
            <span v-else>{{ item.children[0].meta.title }}</span>
          </span>
          <span
            v-else-if="item.children[0].meta && item.children[0].meta.title"
            slot="title"
            >{{ item.children[0].meta.title }}</span
          >
        </el-menu-item>
      </router-link>

      <el-submenu v-else :index="item.name || item.path" :key="item.name">
        <template slot="title">
          <svg-icon
            v-if="item.meta && item.meta.icon"
            :icon-class="item.meta.icon"
          ></svg-icon>
          <span v-if="item.meta && item.meta.title" slot="title">{{
            item.meta.title
          }}</span>

          <!-- ================ 红点泡泡 圆点展示 start ================ -->
          <div
            v-if="unallocatedShowPointWithParent(item)"
            class="unDoPoint unDoDotAni"
          />
          <!-- ================ 红点泡泡 圆点展示 end ================ -->
        </template>

        <template v-for="child in item.children" v-if="!child.hidden">
          <sidebar-item
            :is-nest="true"
            class="nest-menu"
            v-if="child.children && child.children.length > 0"
            :routes="[child]"
            :key="child.path"
          ></sidebar-item>

          <router-link
            v-else
            :to="item.path + '/' + child.path"
            :key="child.name"
          >
            <el-menu-item :index="item.path + '/' + child.path">
              <!-- ================ 红点泡泡 数量展示 start ================ -->
              <div
                v-if="unallocatedShowPointWithChildren(child.path)"
                class="unDoDot unDoDotAni"
              >
                {{ $store.state.app.unallocatedObj[child.path] }}
              </div>
              <!-- ================ 红点泡泡 数量展示 end ================ -->

              <span v-if="child.meta && child.meta.title" slot="title">{{
                child.meta.title
              }}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>
    </template>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import methodCommon from "@/utils/methodCommon";

export default {
  mixins: [mainCommon],
  name: "SidebarItem",
  props: {
    routes: {
      type: Array,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      org_title: document.title, // 分页名称
      reloadTimeInterval: null,
    };
  },
  computed: {
    unallocatedObj() {
      return this.$store.state.app.unallocatedObj;
    },
  },
  watch: {
    // 为显示页签待办数量
    unallocatedObj(row) {
      // 取出拥有菜单，并且不是 hidden 的
      let existMenus = [];
      this.routes.forEach((parEl) => {
        if (parEl.children) {
          parEl.children.forEach((childEl) => {
            if (!childEl.hidden) {
              existMenus.push(childEl.name);
            }
          });
        }
      });

      let todoCount = 0;
      if (row && Object.keys(row).length > 0) {
        for (const key in row) {
          // 如果小红点名称不在菜单上的，就不显示数量在分页上
          if (existMenus.indexOf(key) !== -1) {
            todoCount += parseInt(row[key], 10);
          }
        }
      } else {
        todoCount = 0;
      }
      document.title = `${todoCount ? `(${todoCount})` : ""} ${
        this.$store.state.app.switchProjectObj.title
      } ${methodCommon.methods.translateUserType(this.userInfo.userType)}`;
    },
  },
  created() {
    this.$store.dispatch("GetUnallocatedAll"); // 先打第一次小红点
    let time = this.$store.state.app.intervalTime / 1000;
    this.$store.state.app.reloadTime = time;

    let MinuteTime = this.$store.state.app.intervalMinuteTime / 1000;
    this.$store.state.app.reloadMinuteTime = MinuteTime;

    this.reloadTimeInterval = setInterval(() => {
      // 十秒
      this.$store.state.app.reloadTime--;
      if (this.$store.state.app.reloadTime < 1) {
        this.$store.dispatch("GetUnallocatedAll"); // 更新小红点
        this.$store.state.app.reloadTime = time;
      }

      // 一分钟
      this.$store.state.app.reloadMinuteTime--;
      if (this.$store.state.app.reloadMinuteTime < 1) {
        this.$store.state.app.reloadMinuteTime = MinuteTime;
      }
    }, 1000);
    window.addEventListener("online", this.handleStateChange);
    window.addEventListener("offline", this.handleStateChange);
    // this.getNetworkSpeed(); // 可以测试网络速度
  },
  beforeDestroy() {
    window.removeEventListener("online", this.handleStateChange);
    window.removeEventListener("offline", this.handleStateChange);
    clearInterval(this.reloadTimeInterval);
  },
  methods: {
    handleStateChange() {
      navigator.onLine
        ? this.$notify.success({
            message: "网络正常！",
          })
        : this.$notify.error({
            message: "网络离线，请排查！",
          });
    },
    // getNetworkSpeed() {
    //   let navigatorConnection =
    //     navigator.connection ||
    //     navigator.mozConnection ||
    //     navigator.webkitConnection ||
    //     navigator.msConnection;
    //   if (navigatorConnection) {
    //     console.log(navigatorConnection.effectiveType);
    //     navigatorConnection.onchange = () => {
    //       if (navigator.onLine) {
    //         console.log(navigatorConnection.effectiveType);
    //       }
    //     };
    //   }
    // },
    /* 红点泡泡开始
    搜索该第一层菜单的 children path 是否有匹配到从接口返回的其中一个 obj key 且未读数量为 1 以上
    则在该第一层菜单中展示圆点
    */
    unallocatedShowPointWithParent(item) {
      let obj = Object.keys(this.$store.state.app.unallocatedObj).map(
        (res) => res
      );
      let newObj = item.children.find((items) => obj.includes(items.path));
      // 如果找到了符合的 obj，直接透过 path 返回数量
      if (newObj && this.$store.state.app.unallocatedObj[newObj.path]) {
        return this.$store.state.app.unallocatedObj[newObj.path];
      }
      return false;
    },
    /* 搜索该第二层菜单的 path 有存在相同的 key 且未读数量为 1 以上
    如果有则在该第二层菜单中展示含有數量的红点泡泡
    */
    unallocatedShowPointWithChildren(path) {
      return (
        Object.prototype.hasOwnProperty.call(
          this.$store.state.app.unallocatedObj,
          path
        ) && this.$store.state.app.unallocatedObj[path]
      );
    },
    // 红点泡泡结束

    hasOneShowingChildren(children) {
      if (children.length === 1) {
        return true;
      }
      return false;
    },
    // newYear() {
    //   let textArr = ["天", "汇"];
    //   return textArr[Math.floor(Math.random() * textArr.length)];
    // },
  },
};
</script>

<style scoped>
.menu-wrapper {
  /* 凭证审核员弹框会挡住菜单 */
  padding-bottom: 150px;
}
.menu-wrapper /deep/ li:hover svg {
  animation: svgRotateFrames 1s infinite;
}
@keyframes svgRotateFrames {
  from {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.1);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* .new-year {
  display: inline-block;
  position: relative;
  margin-right: 16px;
  margin-top: -8px;
}
.new-year .bg {
  width: 21px;
  height: 21px;
  background-color: #ff0000;
  box-shadow: 5px 3px 0px #c00000;
  display: inline-block;
  transform: rotate(45deg);
}
.new-year .text {
  width: 23px;
  height: 23px;
  font-weight: 600;
  color: #fff;
  display: inline-block;
  animation: newYearFrames 2s infinite;
  text-align: center;
  position: absolute;
  left: 0px;
  top: 3px;
  font-size: 23px;
  text-shadow: 1px 1px 1px #000;
}
@keyframes newYearFrames {
  from {
    transform: rotateY(0deg);
  }
  50% {
    transform: rotateY(180deg);
  }
  to {
    transform: rotateY(0deg);
  }
} */
.unDoPoint {
  background-color: #f56c6c;
  border-radius: 10px;
  color: #fff;
  font-size: 13px;
  width: 10px;
  height: 10px;
  line-height: 10px;
  position: absolute;
  top: 12px;
  left: 33px;
}
.unDoDot {
  background-color: #f56c6c;
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: 13px;
  height: 18px;
  line-height: 18px;
  padding: 0 5px;
  text-align: center;
  white-space: nowrap;
  margin: -4px 0 0 -24px;
  transform: scale(0);
  position: absolute;
  top: 10px;
  left: 50px;
}
.unDoDotAni {
  animation: unDoDot 0.6s ease-in-out forwards;
  animation-delay: 0.5s;
}
@keyframes unDoDot {
  0% {
    transform: scale(0);
  }
  10% {
    transform: scale(1.1);
  }
  30% {
    transform: scale(0.7);
  }
  60% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.9);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue